const STORAGE_KEY = 'roastresume_history';
const MAX_ITEMS = 50;

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

/**
 * Save an analyzed resume to localStorage.
 * @returns {object} The saved entry (with id and createdAt)
 */
export function saveResume(record) {
  const entry = {
    id: crypto.randomUUID(),
    fileName: record.fileName,
    targetRole: record.targetRole,
    extractedText: record.extractedText || '',
    aiFeedback: record.aiFeedback,
    fileSize: record.fileSize || 0,
    mimeType: record.mimeType || '',
    createdAt: new Date().toISOString(),
  };

  const items = readAll();
  items.unshift(entry);
  if (items.length > MAX_ITEMS) items.length = MAX_ITEMS;
  writeAll(items);
  return entry;
}

/**
 * Paginated history list (newest first). Omits extractedText from list items.
 */
export function getHistory({ page = 1, limit = 9, role = '' } = {}) {
  let items = readAll();

  if (role) {
    const needle = role.toLowerCase();
    items = items.filter((x) => x.targetRole.toLowerCase().includes(needle));
  }

  const total = items.length;
  const pages = Math.max(1, Math.ceil(total / limit) || 1);
  const safePage = Math.min(Math.max(1, page), pages);
  const skip = (safePage - 1) * limit;

  const resumes = items.slice(skip, skip + limit).map(({ extractedText, ...rest }) => rest);

  return {
    resumes,
    pagination: { total, page: safePage, limit, pages },
  };
}

export function getResumeById(id) {
  return readAll().find((x) => x.id === id) || null;
}

export function deleteResume(id) {
  const items = readAll();
  const next = items.filter((x) => x.id !== id);
  if (next.length === items.length) return false;
  writeAll(next);
  return true;
}
